var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import SubjectStatusSelect from '@/components/subject-status-select/SubjectStatusSelect';
import { UserSubject } from '@/models/UserSubject';
import ErrorHandler from '@/support/ErrorHandler';
import AlertCard from '@/components/alert-card/AlertCard';
import Rating from '@/components/rating/Rating';
let EditSubjectStatusDialog = class EditSubjectStatusDialog extends Vue {
    constructor() {
        super(...arguments);
        this.actionList = [];
        this.selectedStatus = 'busy';
        this.showFinishedNote = false;
        this.finishedNote = null;
        this.rating = null;
        this.finishedFile = null;
        this.inputElement = null;
        this.isSubmitting = false;
        this.isSubmitted = false;
        this.isTakingTooLong = false;
        this.totalOperations = 0;
        this.totalOperationsCompleted = 0;
    }
    /**
     * Is the form valid for submission.
     */
    get isDisabled() {
        return false;
    }
    mounted() {
        //
        if (this.defaultStatus) {
            this.selectedStatus = this.defaultStatus;
        }
    }
    onFileChange(event) {
        if (!event.target.files.length === null) {
            return;
        }
        this.inputElement = event.target;
        this.finishedFile = event.target.files[0];
        if (!this.finishedFile) {
            return;
        }
    }
    removeSelectedFile() {
        this.finishedFile = null;
        if (this.inputElement) {
            this.inputElement.removeAttribute('value');
            this.inputElement.setAttribute('value', '');
        }
    }
    clear() {
        this.isSubmitting = false;
        this.isSubmitted = false;
        this.isTakingTooLong = false;
        this.selectedStatus = 'busy';
        this.showFinishedNote = false;
        this.finishedNote = null;
        this.rating = 0;
        this.finishedFile = null;
        this.inputElement = null;
    }
    closeDialog() {
        this.clear();
        this.$emit('input', false);
    }
    submit() {
        this.isSubmitting = true;
        this.update();
    }
    update() {
        console.log('update');
        const subjects = [];
        Object.keys(this.subjects).forEach((subjectId) => {
            const subjectUsers = this.subjects[subjectId];
            subjectUsers.forEach((userId) => {
                subjects.push({
                    subject: subjectId,
                    user: userId,
                });
            });
        });
        const payload = {
            subjects,
            status: this.selectedStatus,
        };
        if (this.selectedStatus === 'finished') {
            payload.finished_note = this.finishedNote || '';
            payload.rating = this.rating || 0;
        }
        if (this.finishedFile) {
            payload.file = this.finishedFile;
            payload.collection = 'finished';
        }
        new UserSubject().bulkUpdate(payload)
            .then(() => {
            this.isSubmitting = false;
            this.$nextTick(() => {
                this.isSubmitted = true;
            });
        })
            .catch((error) => {
            this.isSubmitting = false;
            this.isSubmitted = false;
            ErrorHandler.network(error);
        });
    }
    isSubmittingChanged(isSubmitting, wasUploading) {
        if (isSubmitting) {
            this.takingTooLongTimeout = setTimeout(() => {
                this.isTakingTooLong = true;
            }, 30000);
        }
        else {
            this.isTakingTooLong = false;
            clearTimeout(this.takingTooLongTimeout);
        }
    }
    isSubmittedChanged(isSubmitted, wasSubmitted) {
        if (isSubmitted) {
            this.$emit('status-changed');
        }
    }
    newRating(rating) {
        this.rating = rating;
    }
    onDefaultStatus() {
        this.selectedStatus = this.defaultStatus;
    }
    selectedStatusChanged(status) {
        if (status === 'finished') {
            this.showFinishedNote = true;
        }
        else {
            this.showFinishedNote = false;
        }
    }
};
__decorate([
    Prop({ default: () => { } }),
    __metadata("design:type", typeof (_a = typeof Object !== "undefined" && Object) === "function" ? _a : Object)
], EditSubjectStatusDialog.prototype, "subjects", void 0);
__decorate([
    Prop({ default: 'busy' }),
    __metadata("design:type", String)
], EditSubjectStatusDialog.prototype, "defaultStatus", void 0);
__decorate([
    Prop({ default: '' }),
    __metadata("design:type", String)
], EditSubjectStatusDialog.prototype, "input", void 0);
__decorate([
    Watch('isSubmitting'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean, Boolean]),
    __metadata("design:returntype", void 0)
], EditSubjectStatusDialog.prototype, "isSubmittingChanged", null);
__decorate([
    Watch('isSubmitted'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean, Boolean]),
    __metadata("design:returntype", void 0)
], EditSubjectStatusDialog.prototype, "isSubmittedChanged", null);
__decorate([
    Watch('defaultStatus'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], EditSubjectStatusDialog.prototype, "onDefaultStatus", null);
__decorate([
    Watch('selectedStatus'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], EditSubjectStatusDialog.prototype, "selectedStatusChanged", null);
EditSubjectStatusDialog = __decorate([
    Component({
        components: {
            SubjectStatusSelect,
            AlertCard,
            Rating,
        },
    })
], EditSubjectStatusDialog);
export default EditSubjectStatusDialog;
